import { createAction } from 'redux-actions';

export const addSeries = createAction('ADD_SERIES', series => ({ series }));
export const addSeriesSuccess = createAction('ADD_SERIES_SUCCESS', series => ({ series }));
export const addSeriesFail = createAction('ADD_SERIES_FAIL');

export const getSeries = createAction('GET_SERIES', siteId => ({ siteId }));
export const getSeriesSuccess = createAction('GET_SERIES_SUCCESS', (series, siteId) => ({ series, siteId }));
export const getSeriesFail = createAction('GET_SERIES_FAIL');

export const getSeriesPosts = createAction('GET_SERIES_POSTS', (siteId, seriesId) => ({ siteId, seriesId }));
export const getSeriesPostsSuccess = createAction('GET_SERIES_POSTS_SUCCESS', posts => ({ posts }));
export const getSeriesPostsFail = createAction('GET_SERIES_POSTS_FAIL', posts => ({ posts: posts || [] }));

export const addPostToSeries = createAction('ADD_POST_TO_SERIES', (siteId, seriesId, postId) => ({
  siteId,
  seriesId,
  postId,
}));
export const addPostToSeriesSuccess = createAction('ADD_POST_TO_SERIES_SUCCESS');
export const addPostToSeriesFail = createAction('ADD_POST_TO_SERIES_FAIL');

export const removePostFromSeries = createAction('REMOVE_POST_FROM_SERIES', (siteId, seriesId, postId) => ({
  siteId,
  seriesId,
  postId,
}));
export const removePostFromSeriesSuccess = createAction('REMOVE_POST_FROM_SERIES_SUCCESS');
export const removePostFromSeriesFail = createAction('REMOVE_POST_FROM_SERIES_FAIL');

export const setSeriesQuery = createAction('SET_SERIES_QUERY', seriesQuery => ({ seriesQuery }));
export const updateSeries = createAction('UPDATE_SERIES', (siteId, series) => ({ siteId, series }));
export const updateSeriesSuccess = createAction('UPDATE_SERIES_SUCCESS', series => ({ series }));
export const updateSeriesFail = createAction('UPDATE_SERIES_FAIL');

export const getSeriesById = createAction('GET_SERIES_BY_ID');
export const getSeriesByIdSuccess = createAction('GET_SERIES_BY_ID_SUCCESS');
export const getSeriesByIdFail = createAction('GET_SERIES_BY_ID_FAIL');
export const clearSeriesCache = createAction('CLEAR_SERIES_CACHE');
